import React, { useEffect, useMemo, useRef } from 'react';
import { useStore } from 'react-redux';
import createUiStorage from './storage.js';
const initialValue = {
    exodus: {},
    selectors: {},
    storage: undefined,
};
const HeadlessContext = React.createContext(initialValue);
export const HeadlessProvider = ({ exodus, adapters, selectors, children, }) => {
    const store = useStore();
    if (!store) {
        throw new Error('HeadlessProvider must be a descendant of a Redux <Provider> component');
    }
    const storage = useRef(createUiStorage(adapters.storage));
    useEffect(() => {
        storage.current?.get().then((state) => store.dispatch({ type: 'UI_LOAD', payload: state }));
    }, [store]);
    const value = useMemo(() => ({ exodus, selectors, storage: storage.current }), [exodus, selectors]);
    return React.createElement(HeadlessContext.Provider, { value: value }, children);
};
export default HeadlessContext;
